import { Descriptions, Table, TableColumnsType } from "antd";
import _ from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { getSurveyQuestion, updateSurveyQuestion } from "../../../api/surveyQuestion.api";
import Button from "../../../components/Button";
import ErrorResponse from "../../../components/ErrorResponse";
import SimpleHeader from "../../../components/layout/SimpleHeader";
import Loader from "../../../components/Loader";
import Radio from "../../../components/Radio";
import useAuth from "../../../hooks/useAuth";
import useAxios from "../../../hooks/useAxios";
import useNotification from "../../../hooks/useNotification";
import { getCommonCodeLabel } from "../../../lib/store";
import { IGetSurveyQuestion, ISurveyQuestionDetail } from "../../../models/surveyQuestion.model";

interface IMatch {
  questionCode: string;
}

const SurveyQuestionRead = () => {
  const { t } = useTranslation();
  const { writeAuthYn } = useAuth();
  const match = useRouteMatch<IMatch>();
  const questionCode = Number(match.params.questionCode);
  const history = useHistory();
  const location = useLocation();

  const { successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetSurveyQuestion>();
  const { data: submitRes, isLoading: submitIsLoading, error: submitError, execute: submitExecute } = useAxios();

  const [useYn, setUseYn] = useState<string>();

  useEffect(() => {
    if (questionCode) {
      execute(getSurveyQuestion(questionCode));
    }
  }, [questionCode]);

  useEffect(() => {
    if (res && !isLoading) {
      setUseYn(res?.data?.useYn);
    }
  }, [res, isLoading]);

  useEffect(() => {
    if (submitRes && !submitIsLoading) {
      successNotification(t('common.message.save1'));
    }
  }, [submitRes, submitIsLoading]);

  const onSubmit = () => {
    const req: any = _.cloneDeep(res?.data);
    req.questionDetail = req.questionInfo;
    req.useYn = useYn;
    submitExecute(updateSurveyQuestion(questionCode, req));
  }

  const columns: TableColumnsType<ISurveyQuestionDetail> = [
    {
      title: t('homepage.survey.column11'),
      dataIndex: 'questionContent',
      key: 'questionContent',
    },
    {
      title: t('common.column.score'),
      dataIndex: 'score',
      key: 'score',
      align: 'center',
    },
  ];

  return (
    <div className="content scrollbar">
      {isLoading || submitIsLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={submitError} />
      <SimpleHeader
        iconFile="icon-homepage-big.svg"
        parentMenu={t('common.menu.homepage')}
        currentMenu={t('homepage.surveyQuestion.title4')}
      />

      <div className='comm-table__area rowType'>
        <Descriptions
          bordered
          column={4}
          size="small"
          labelStyle={{ width: '12.5%' }}
          contentStyle={{ width: '12.5%' }}
        >
          <Descriptions.Item label={t('homepage.survey.column12')} span={4}>
            {res?.data?.title}
          </Descriptions.Item>
          <Descriptions.Item label={t('common.menu.campus')}>
            {res?.data?.campusKorName}
          </Descriptions.Item>
          <Descriptions.Item label={t('common.column.category')}>
            {getCommonCodeLabel('HP0007', res?.data?.surveyCategory || '', 'ko')}
          </Descriptions.Item>
          <Descriptions.Item label={t('homepage.survey.column1')}>
          {getCommonCodeLabel('HP0006', res?.data?.questionType || '', 'ko')}
          </Descriptions.Item>
          <Descriptions.Item label={t('homepage.surveyQuestion.column1')}>
            {moment(res?.data?.regDate).format('YYYY.MM.DD')}
          </Descriptions.Item>
          <Descriptions.Item label={t('homepage.surveyQuestion.column2')} span={4}>
            <div className="comm-btn__area">
              <div className="mt-1">
                <Radio
                  checked={useYn === 'Y'}
                  onChange={() => setUseYn('Y')}
                  text={t('common.option.yes')}
                />
                <Radio
                  className="ml-4"
                  checked={useYn === 'N'}
                  onChange={() => setUseYn('N')}
                  text={t('common.option.no')}
                />
              </div>
              <Button
                onClick={onSubmit}
                className="btn-basic small pink ml-2"
                text={t('common.button.save')}
                writeAuthYn={writeAuthYn}
              />
            </div>
          </Descriptions.Item>
        </Descriptions>
      </div>

      <div className='comm-table__area'>
        <Table
          columns={columns}
          dataSource={res?.data?.questionInfo}
          pagination={{ pageSize: 99999 }}
        />
      </div>
      <div className="comm-bx__space">
        <div className="comm-btn__area">
          <Button
            onClick={() => history.push(`/homepage/survey-question${location.search}`)}
            className="btn-basic gray-line"
            text={t('common.button.list')}
          />
        </div>
      </div>

    </div>
  );
}

export default SurveyQuestionRead;
